export default __webpack_public_path__ + "static/timberline-l-series-28-orbital-19g-19g-tanks-af92a507745017ef312abb2d1d7c55bb.jpg";